<script lang="ts">
import AppLayout from "@/Layouts/App.vue";
import BreezeInput from "@/Components/Input.vue";
import BreezeLabel from "@/Components/Label.vue";
import { defineComponent, PropType } from "vue";
import GenericButton from "@/Components/Generics/GenericButton.vue";

export default defineComponent({
    components: {
        GenericButton,
        BreezeInput,
        BreezeLabel,
    },
    layout: AppLayout,

    props: {
        form: {
            type: Object as PropType<{
                name: string;
                email: string;
                password: string;
                password_confirmation: string;
                terms: boolean;
                type: "school" | "company";
            }>,
            required: true,
        },
    },
});
</script>

<template>
    <form class="full-width">
        <div class="flex flex--width flex--v flex--gap-20">
            <div class="flex flex--v flex--gap-5">
                <breeze-label for="name" :value="$trans('auth.name')" />
                <breeze-input id="name" v-model="form.name" type="text" required autofocus autocomplete="name" />
            </div>

            <div class="flex flex--v flex--gap-5">
                <breeze-label for="email" :value="$trans('auth.email')" />
                <breeze-input id="email" v-model="form.email" type="email" required autocomplete="username" />
            </div>

            <div class="flex flex--v flex--gap-5">
                <breeze-label for="password" :value="$trans('auth.password')" />
                <breeze-input id="password" v-model="form.password" type="password" required autocomplete="new-password" />
            </div>

            <div class="flex flex--v flex--gap-5">
                <breeze-label for="password_confirmation" :value="$trans('auth.password_confirm')" />
                <breeze-input id="password_confirmation" v-model="form.password_confirmation" type="password" class="mt-1 block w-full" required autocomplete="new-password" />
            </div>

            <div class="flex flex--width flex--v flex--valign-c flex--gap-20">
                <GenericButton type="submit" class="login-button" :title="$trans('auth.register')" :disabled="form.processing" :click-stop="false" />

                <!-- <div class="flex flex--v flex--valign-c flex--gap-10"> -->
                <InertiaLink :href="route('login')" class="inertia-link text text--less-gap text--primary-b text--size-16 text--center">{{ $trans("auth.already_registered") }}</InertiaLink>
                <!-- </div> -->
            </div>
        </div>

        <!-- <div class="flex items-center justify-end mt-4" style="display: flex; justify-content: space-between; align-items: center">
            <breeze-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing">{{ $trans("auth.register").toUpperCase() }}</breeze-button>

            <inertia-link :href="route('login')" class="underline text-sm text-gray-600 hover:text-gray-900">{{ $trans("auth.already_registered") }}</inertia-link>
        </div> -->
    </form>
</template>

<style lang="scss" scoped>
.login-button {
    height: rem(45);
    margin-top: rem(5);
}
.inertia-link {
    &:hover {
        text-decoration: underline;
    }
}
.form-check label {
    line-height: 1.5em;
}
</style>
